export default "__VITE_ASSET__DUhQNS8j__"